import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { tr } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

const CAPTION = {
  caption_dropdowns: "flex gap-2",
  dropdown_month: "relative inline-flex items-center",
  dropdown_year: "relative inline-flex items-center",
  dropdown: "absolute inset-0 w-full opacity-0 cursor-pointer z-10",
  caption_label: "inline-flex items-center gap-1 text-sm font-medium px-2 py-1 rounded-md border border-border capitalize",
  vhidden: "sr-only",
  dropdown_icon: "w-3 h-3",
};

export default function DateInput({ value, onChange, className, disabled, placeholder = "gg.aa.yyyy", "data-testid": testid }) {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  const valid = date && isValid(date);
  const emit = (v) => onChange?.({ target: { value: v } });
  const pick = (d) => { emit(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled} data-testid={testid}
          className={cn("w-full justify-start font-normal px-3", !valid && "text-muted-foreground", className)}>
          <CalendarDays className="w-4 h-4 mr-2 shrink-0 opacity-70" />
          <span className="font-mono-nums">{valid ? format(date, "dd.MM.yyyy") : placeholder}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={testid ? `${testid}-calendar` : undefined}>
        <Calendar mode="single" locale={tr} weekStartsOn={1} selected={valid ? date : undefined} onSelect={pick}
          defaultMonth={valid ? date : new Date()} captionLayout="dropdown-buttons" fromYear={2015} toYear={2035}
          classNames={CAPTION} initialFocus />
        <div className="border-t border-border p-2 flex justify-between">
          <Button type="button" size="sm" variant="ghost" onClick={() => pick(null)} data-testid={testid ? `${testid}-clear` : undefined}>Temizle</Button>
          <Button type="button" size="sm" variant="ghost" onClick={() => pick(new Date())} data-testid={testid ? `${testid}-today` : undefined}>Bugün</Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
